import React, { useState } from "react";
import FileBrowser from "../../../shared/fileBrowser/FileBrowser";
import { Button, Grid } from "@mui/material";
import styles from "./UploadNewTermsAndConditions.module.scss";
import pdfIcon from "../../../imgs/pdf-acrobat-icon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FileEncoder from "../../../utils/FileEncoder";
import { withTranslation } from "react-i18next";
import { InfoIconWithMessage } from "../../../shared/infoIcon/InfoIcon";
import TermsAndConditionsClient from "../../../shared/clients/TermsAndConditionsClient";

const UploadNewTermsAndConditions = (props) => {
  const [file, setFile] = useState(null);
  const [displayDetails, setDisplayDetails] = useState(false);
  const [enablePublish, setEnablePublish] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState("");
  const [displayError, setDisplayError] = useState(false);

  const onFileSelected = (selectedFile) => {
    if (
      selectedFile.size > 1000000 ||
      selectedFile.type !== "application/pdf"
    ) {
      setDisplayError(true);
      setFile(null);
      setDisplayDetails(false);
    } else {
      setFile(selectedFile);
      setDisplayDetails(true);
      setDisplayError(false);
    }
  };

  const uploadNewTermsAndConditions = () => {
    if (enablePublish) {
      props.hideOrShow(true);
      const date = effectiveDate;

      new FileEncoder()
        .encode(file)
        .then((data) => {
          const termsAndConditions = {
            file: data,
            nscId: props.user.userId,
            effectiveDate:
              date.getDate() +
              "/" +
              (date.getMonth() + 1) +
              "/" +
              date.getFullYear(),
          };

          props.hideOrShow(true);
          TermsAndConditionsClient.uploadTermsAndConditions(
            props.user,
            termsAndConditions
          )
            .then(() => {
              props.loadTermsAndConditionsHistory();
              removeFile();
            })
            .catch(() => {})
            .finally(() => {
              props.hideOrShow(false);
            });
        })
        .catch(() => {})
        .finally(() => {
          props.hideOrShow(false);
        });
    }
  };

  const selectEffectiveDate = (date) => {
    if (date !== null) {
      setEffectiveDate(date);
      setEnablePublish(true);
    }
  };

  const removeFile = () => {
    const fileInput = document.getElementById("pdf-file");
    if (fileInput) {
      fileInput.value = "";
    }
    setFile(null);
    setDisplayDetails(false);
    setEnablePublish(false);
    setEffectiveDate("");
  };

  return (
    props.enableUpload !== undefined && (
      <div className={styles.uploadTermsAndConditions}>
        {props.enableUpload ? (
          <>
            <div className="pagePadding">
              <InfoIconWithMessage
                message={props.t("BusinessSettings.termsandConditionsHeader")}
              />
            </div>
            <div className="pagePaddingLeft">
              <FileBrowser
                fileType=".pdf"
                onFileSelected={onFileSelected}
                id="pdf-file"
              >
                <Button
                  className={styles.uploadBtn}
                  component="span"
                  id="upload-file-btn"
                >
                  {props.t("BusinessSettings.uploadNewTermsAndConditions")}
                </Button>
              </FileBrowser>
              <p className={styles.fileTypeText}>
                {props.t("UploadTermsConditions.tipText")}
              </p>
              {displayError && (
                <div className={styles.warningDiv}>
                  <div className={styles.warning}></div>
                  <div className={styles.errorText}>
                    {props.t("Error.fileError")}
                  </div>
                </div>
              )}
            </div>
            {displayDetails && (
              <>
                <Grid
                  container
                  className={`${styles.effectiveBox} pagePaddingLeft`}
                  id="effectiveRow"
                >
                  <Grid item xs={4} className={styles.effectiveDateRow}>
                    <div className={styles.fileNameTextBox}>
                      <div>
                        <img src={pdfIcon} alt="PDF" />
                        <p>{file.name}</p>
                      </div>
                      <div
                        className={styles.clearImage}
                        id="removeFile"
                        onClick={removeFile}
                      >
                        <ClearIcon />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={8} className={styles.effectiveDateRow}>
                    <span className={styles.effectiveText}>
                      {props.t("BusinessSettings.effectiveFrom")}
                    </span>
                    <DatePicker
                      selected={effectiveDate}
                      onChange={selectEffectiveDate}
                      id="effectiveDate"
                      dateFormat="dd/MM/yyyy"
                      placeholderText="dd/mm/yy"
                      minDate={new Date()}
                    />
                  </Grid>
                </Grid>
                <div className={styles.publishButton}>
                  <Button
                    type="button"
                    onClick={uploadNewTermsAndConditions}
                    className="greenBtn"
                    id="publish-action-btn"
                    disabled={!enablePublish}
                  >
                    {props.t("BusinessSettings.publish")}
                  </Button>
                </div>
              </>
            )}
          </>
        ) : (
          <div id="termsHeaderWithWarning" className="pagePadding">
            <InfoIconWithMessage
              message={[
                props.t("BusinessSettings.termsandConditionsHeader"),
                " ",
                <span key="warning" className={styles.previewTitleWarning}>
                  {props.t("BusinessSettings.maximumUploadWarning")}
                </span>,
              ]}
            />
          </div>
        )}
      </div>
    )
  );
};

export default withTranslation("emp")(UploadNewTermsAndConditions);
